import React from 'react';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';

import { Reference } from './Reference';


export interface ReferenceItem {
  id: string;
  datasetId: string;
  name: string;
  url?: string | null;
  icon?: React.ReactNode;
}

interface ReferencesProps {
  data: ReferenceItem[];
}

export const References: React.FC<ReferencesProps> = observer(({ data }) => {
  // Every source gets a card, with or without a URL, so an inline `[n]` marker
  // always resolves to something visible; a card with no URL simply isn't a link.
  const references = data || [];

  if (references.length === 0) {
    return null;
  }

  return (
    <Box sx={{ marginTop: 1, marginBottom: 1.5 }}>
      <Typography variant="body2" sx={{ display: 'block', marginBottom: 1.5, fontWeight: 600 }}>
        <Trans i18nKey="chat.references.title" />
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'stretch' }}>
        {references.map((ref, index) => (
          <Reference
            key={`${ref.datasetId}-${ref.id}`}
            id={ref.id}
            datasetId={ref.datasetId}
            name={ref.name}
            url={ref.url}
            // 1-based to match the `[n]` markers the assistant writes.
            number={index + 1}
          />
        ))}
      </Box>
    </Box>
  );
});
